import { render, staticRenderFns } from "./ShareResult.vue?vue&type=template&id=7a908ddf&scoped=true&"
import script from "./ShareResult.vue?vue&type=script&lang=js&"
export * from "./ShareResult.vue?vue&type=script&lang=js&"
import style0 from "./ShareResult.vue?vue&type=style&index=0&id=7a908ddf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a908ddf",
  null
  
)

export default component.exports